import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { PaakConversionPageLoader } from 'sdk-paak-conversion-page'

export const usePaakAd = ({
  campaign,
  requestWithUserId,
  userId,
}: { campaign: Api.CampaignResBody; requestWithUserId: boolean; userId?: number }) => {
  // 単位は[ms]としている
  // Date.now()で取れるのがミリ秒のため
  const router = useRouter()
  const localStorageKey = `${process.env.NEXT_PUBLIC_SERVICE_NAME}-expiration-time`

  useEffect(() => {
    const expiration: string | null = localStorage.getItem(localStorageKey)
    // 条件に応じて実行するかどうかを決める
    const isAdRedirect = (): boolean => {
      // epochは[ミリ秒]にしているので注意すること
      const currentEpoch = Date.now()
      if (expiration === null) {
        return true
      } else if (Number.parseInt(expiration) <= currentEpoch) {
        return true
      }
      return false
    }

    // 以前の広告効果計測
    // PoCのキャンペーンが終わったら削除する
    const previousPaakAd = () => {
      if (requestWithUserId && !userId) {
        return
      }
      if (campaign && campaign.ad) {
        new PaakConversionPageLoader({
          backendEndpoint: process.env.NEXT_PUBLIC_AD_BACKEND_API_ENDPOINT,
          backendApiKey: campaign.adKey,
          isSetScript: false,
        })
          .loadWithGeo()
          .then((res) => {
            res.onConversion({ userId }).catch((v) => console.log(v))
          })
      }
    }
    // 広告効果計測
    const paakAd = () => {
      if (campaign && campaign.ad) {
        const adKey = campaign.adKey
        const adRedirectUrl = campaign.adRedirectUrl
        const adRedirectExpire = campaign.adRedirectExpire
        localStorage.setItem(localStorageKey, (Date.now() + adRedirectExpire * 1000).toString())
        const params = new URLSearchParams()
        params.append('key', adKey)
        params.append('endpoint', process.env.NEXT_PUBLIC_AD_BACKEND_API_ENDPOINT)
        if (userId) {
          params.append('id', userId.toString())
        }
        const fullUrl = `${adRedirectUrl}?${params.toString()}`
        router.push(fullUrl)
      }
    }
    if (isAdRedirect()) {
      paakAd()
    }
    previousPaakAd()
  }, [campaign, userId])
}
